module.exports = __webpack_public_path__ + "img/10.35615204.jpg";